export default {
  moveToCart: false,
  loginRequired: false,
  sharedWishlistPageHandle: "shared-wishlist",
  wishlistPageHandle: "wishlist",
  klaviyo: false,
  facebookPixel: false,
  googleAnalytics: false,
}
